import { generalActions } from "../store/actions";
import store from "../store";

// Avoid flooding the single-slot toast with repeated "too many requests"
// messages when a burst of parallel requests all get rate-limited at once.
const TOAST_DEDUPE_WINDOW_MS = 3000;
let lastToastAt = 0;

const DEFAULT_MESSAGE = "Too many requests. Please try again later.";

export const isRateLimitError = (error) => error?.response?.status === 429;

export const handleRateLimitError = (error) => {
  if (!isRateLimitError(error)) return;

  const now = Date.now();
  if (now - lastToastAt < TOAST_DEDUPE_WINDOW_MS) return;
  lastToastAt = now;

  store.dispatch(
    generalActions.showToast({
      title: error?.response?.data?.message || DEFAULT_MESSAGE,
      type: "error",
    })
  );
};
